import {
  VISIBLE_RANGE_PROFILE_STUDIES,
  type VisibleRangeProfileKind,
} from '@/features/chart/lib/visible-range-profile-studies'
import type { VisibleRangeProfileUnit } from '@/types/dashboard'

export type VisibleRangeProfileLegendUnits = Record<
  VisibleRangeProfileKind,
  VisibleRangeProfileUnit
>

export function resolveMeasureLegendLabel(
  currentLabel: string,
  unitsByLabel: Readonly<Record<string, VisibleRangeProfileUnit>>
) {
  for (const [label, unit] of Object.entries(unitsByLabel)) {
    if (
      currentLabel === label ||
      currentLabel === `${label} base` ||
      currentLabel === `${label} quote`
    ) {
      return `${label} ${unit}`
    }
  }

  return null
}

export function resolveVisibleRangeProfileLegendLabel(
  currentLabel: string,
  units: VisibleRangeProfileLegendUnits
) {
  return resolveMeasureLegendLabel(
    currentLabel,
    Object.fromEntries(
      (
        Object.entries(VISIBLE_RANGE_PROFILE_STUDIES) as Array<
          [VisibleRangeProfileKind, (typeof VISIBLE_RANGE_PROFILE_STUDIES)[VisibleRangeProfileKind]]
        >
      ).map(([kind, definition]) => [definition.shortDescription, units[kind]])
    )
  )
}
